import React, { FC } from 'react'
import WrapperImage from '../../../../global/wrapperImage'

type Props = {
  partnersListingNameTypes: any
  becomeAPartnerObj: any
  arrowLongRight: any
}

const BecomeAPartner: FC<Props> = ({
  partnersListingNameTypes,
  becomeAPartnerObj,
  arrowLongRight,
}) => {
  return (
    <>
      <div className="PartnersLocator__filter PartnersLocator__filter--mobile">
        <h4 className="PartnersLocator__becomePartnerTitle">
          Apply to become a{' '}
          {partnersListingNameTypes?.length >= 2 && partnersListingNameTypes[1].value
            ? partnersListingNameTypes[1].value
            : 'Technology Partner'}
        </h4>

        <p className="PartnersLocator__becomePartnerDesc">
          Join forces with UiPath to fast-track portfolio innovation, expand your capabilities and
          accelerate demand.
        </p>

        <a
          className="PartnersLocator__becomePartnerCTA Button Button--secondary"
          href={becomeAPartnerObj[1]?.value}
          rel=" noopener">
          {becomeAPartnerObj[0]?.value}
        </a>
      </div>

      <div className="PartnersLocator__filter PartnersLocator__filter--mobile">
        <h4 className="PartnersLocator__becomePartnerTitle">Access pre-built integrations</h4>

        <p className="PartnersLocator__becomePartnerDesc">
          Download pre-built integrations and other reusable components on the UiPath Marketplace.
        </p>

        <a
          className="PartnersLocator__becomePartnerCTA PartnersLocator__becomePartnerCTA--link"
          href="https://connect.uipath.com/"
          target="_blank"
          rel=" noopener">
          Go to the UiPath Marketplace
          <WrapperImage src={arrowLongRight} width={24} height={24} threshold={650} />
        </a>
      </div>
    </>
  )
}

export default BecomeAPartner
